import { Directive, ElementRef, Input, AfterViewInit, Inject, PLATFORM_ID, Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { environment } from '../../environments/environment';
import { CommonFunctionsService,NgxToasterService, UserService } from '../_services/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

declare var paypal:any;
@Injectable()
@Directive({
    selector: '[paypal]',
    providers:[CommonFunctionsService,UserService,NgxToasterService]
})
export class Paypal implements AfterViewInit {

    env = environment;
    @Input('paypal') totalAmount: string = '';
    @Input('user_id') user_id : string = '';
    @Input('desc_id') desc_id : string = '';
    @Input('amount') amount : string = '';
    @Input('payment_type') payment_type : string = 'plan';
    private ngUnsubscribe: Subject<void> = new Subject<void>();	

    constructor(
        private el: ElementRef,public router: Router,
        private userService:UserService,
		private NgxToasterService: NgxToasterService,
		@Inject(PLATFORM_ID) private platformId: object,
        private commonFunctionsService: CommonFunctionsService
    ) { }    
	ngAfterViewInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			let that =this;
			let amount = this.totalAmount;
			let client_id = this.user_id;
			let desc_id = this.desc_id;
			
			setTimeout(()=>{
				paypal.Buttons({
					style: { 
					shape: 'rect',
					color: 'blue',
					layout: 'horizontal',
					label: 'paypal',		
					size: 'responsive',		
					height: 40,
					tagline: false
					},
	
					createOrder: function (data : any , actions : any) {
						return actions.order.create({
							purchase_units: [{
								"amount":{"currency_code":"USD","value":amount},
								"reference_id":client_id,
								"description": desc_id 
							}]
						});
					},
	
					onApprove: function (data : any , actions : any) {
						return actions.order.capture().then(function(details : any) {
							that.paymentComplete(details);
						});
					},
					onCancel:  (data : any , actions : any) => {
						that.cancelRedirect();
					},
					onError: (err : any)=> {
						
					},
					onClick: (data : any , actions : any) => {
						
					},
				}).render(this.el.nativeElement);
			},1000);
		}
    }
	/**This function is used to save payment data in order */
	public paymentComplete(data:any){
        let formData:any			=	{};
		formData['payment_data']	=	data;
		this.PymentSuccess(formData);
	}

	public PymentSuccess(formData:any){
		if(this.payment_type == 'plan'){
			this.commonFunctionsService.makePayment(formData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
				if(res.status == this.env.SUCCESS_STATUS){
					this.userService.updateCurrentUserData();
					this.router.navigate(['/thank-you'])
				}
			})
		}else if(this.payment_type == 'resume'){
			formData['user_id']		=	this.userService.getCurrentUser()._id;
			formData['slug_name']	=	this.desc_id;
			formData['amount']		=	this.amount;
			this.commonFunctionsService.makeResumePayment(formData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
				if(res.status == this.env.SUCCESS_STATUS){
					this.userService.updateCurrentUserData();
					this.router.navigate(['/thank-you/resume'])
				}
			})
		}else{
			formData['user_id']	=	this.userService.getCurrentUser()._id;
			formData['template_id']	=	this.desc_id;
			this.commonFunctionsService.purchaseResumeTemplate(formData).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res:any)=>{
				if(res.status == this.env.SUCCESS_STATUS){
					this.userService.updateCurrentUserData();
					this.router.navigate(['/thank-you'])
				}
			});
		}
	} 

	public cancelRedirect(){
		this.NgxToasterService.showError("Payment has been cancelled.");
	}
}




